export default "__VITE_ASSET__BPUnQipK__"